import { render, staticRenderFns } from "./CaseInvoiceView.vue?vue&type=template&id=2a1ba445&"
import script from "./CaseInvoiceView.vue?vue&type=script&lang=js&"
export * from "./CaseInvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports